import Crud from '../views/Manual/Crud'
import Add from '../views/Manual/Add'
import View from '../views/Manual/View'

let routes = {
    path: '/manuais',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/manuais',
            name: 'list-manuais',
            component: Crud,
            meta: {
                pageTitle: "Lista de Manuais",
                breadcrumb: [
                    {
                        text: "manuais",
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/manuais/add',
            name: 'NewManual',
            component: Add,
            meta: {
                pageTitle: 'Criação de Manuais',
                breadcrumb: [
                    {
                        text: 'Manuais',
                        active: false,
                        to: '/manuais',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/manuais/edit/:id?',
            name: 'ViewManual',
            component: Add,
            meta: {
                pageTitle: "Editar Manual",
                breadcrumb: [
                    {
                        text: "manuais",
                        active: false,
                        to: '/manuais',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/manuais/view/:id',
            name: 'ShowManual',
            component: View,
            meta: {
                pageTitle: "Visualizar Manual",
                breadcrumb: [
                    {
                        text: "manuais",
                        active: false,
                        to: '/manuais',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
    ]
};


export default routes
